// Motor de la guía (GuiaInteractiva) para las pantallas a pantalla completa que
// no usan Layout, como la ficha de presupuesto (/presupuestos/:id). Solo se
// pinta cuando lo que está en marcha es una novedad (NovedadesPendientes.js):
// el tour de bienvenida sigue viviendo solo en las pantallas con Layout, igual
// que siempre.
import React, { useEffect, useState } from 'react';
import { useGuia } from '../../context/GuiaContext';
import GuiaInteractiva from './GuiaInteractiva';

const esMovil = () => {
  try {
    return window.innerWidth < 768;
  } catch (e) {
    return false;
  }
};

const MotorNovedad = () => {
  const [isMobile, setIsMobile] = useState(esMovil);

  useEffect(() => {
    const alCambiar = () => setIsMobile(esMovil());
    window.addEventListener('resize', alCambiar);
    return () => window.removeEventListener('resize', alCambiar);
  }, []);

  return <GuiaInteractiva isMobile={isMobile} />;
};

const GuiaSinLayout = () => {
  const { estado } = useGuia();
  if (!estado || !estado.novedad) return null;
  return <MotorNovedad />;
};

export default GuiaSinLayout;
